var _defs, _path, _path2, _path3, _circle, _rect, _circle2, _circle3, _rect2, _rect3, _rect4, _rect5, _circle4, _circle5, _rect6, _rect7, _rect8, _circle6, _rect9, _rect0, _rect1, _circle7, _circle8, _rect10, _rect11, _rect12, _circle9, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _path16, _path17, _path18, _path19, _path20, _path21, _rect13, _path22, _path23, _circle0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieRegion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 616.21354 326.79632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-21 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #bcd86b;\n      }\n\n      .cls-3 {\n        fill: #77c58c;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #f2f2f2;\n      }\n\n      .cls-6 {\n        fill: #e3e3e3;\n      }\n\n      .cls-7 {\n        fill: #dde3e9;\n      }\n\n      .cls-8 {\n        fill: #c5cfd6;\n      }\n\n      .cls-9 {\n        fill: #afb9c5;\n      }\n\n      .cls-10 {\n        fill: #66c3ec;\n      }\n\n      .cls-11 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-12 {\n        fill: #bbd773;\n      }\n\n      .cls-13 {\n        fill: #454545;\n      }\n\n      .cls-14 {\n        fill: #757575;\n      }\n\n      .cls-15 {\n        fill: #e0c1a4;\n      }\n\n      .cls-16 {\n        fill: #987f51;\n      }\n\n      .cls-17 {\n        fill: #6bad7c;\n      }\n\n      .cls-18 {\n        fill: #79c48e;\n      }\n\n      .cls-19 {\n        isolation: isolate;\n        opacity: 0.15;\n      }\n\n      .cls-20 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-21 {\n        stroke: #d94c3c;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n        stroke-dasharray: 6 8;\n      }\n\n      .cls-22 {\n        fill: #eb5241;\n      }\n\n      .cls-23 {\n        fill: #555;\n      }\n\n      .cls-24 {\n        fill: #919191;\n      }\n\n      .cls-25 {\n        fill: #f8f8f8;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.19,200.16423a93.11184,93.11184,0,1,1,5.48-30.624A93.12007,93.12007,0,0,1,326.19,200.16423Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.905,137.23527A93.11892,93.11892,0,1,1,207.082,256.3422"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Leaf",
    className: "cls-2",
    d: "M466.93692,133.36284c8.11045-8.354,16.24908-16.604,25.31471-23.95645,5.34029-4.33482,10.968-8.27644,16.47949-12.38458q-.954.83564-1.87174,1.72118c1.72087-1.16849,3.97323-1.82881,5.79715-2.90964,2.03567-1.20561,3.97969-2.58549,5.88712-3.97667,3.72447-2.71391,7.39163-5.47977,11.21964-8.0518,4.26462-2.86558,8.68483-5.51373,13.02185-8.27091a117.2041,117.2041,0,0,1,11.345-6.815c2.14636-1.04331,4.29474-2.27548,6.453-3.36618.72109-.36356,8.04042-4.98594,8.02444-4.998-.4043-.30462-4.08959,1.428-4.65714,1.65923-1.66316.67962-3.2546,1.49345-4.85443,2.30346a21.1991,21.1991,0,0,0,1.95081-5.46692c.117-.59079,1.05579-4.89246.57638-5.25366-.2397-.1806-2.57437,7.51978-2.69384,8.26021a13.684,13.684,0,0,1-.281,2.03541c-.31715.91968-.30193.6418-1.00035,1.16147a43.86058,43.86058,0,0,1-4.37652,2.33913,31.98914,31.98914,0,0,1-4.4642,2.54862c-4.226,2.05294-8.5089,5.2104-12.52349,7.83224a29.52681,29.52681,0,0,0,2.43369-6.23918c.13819-.51591,1.63936-5.13667,1.275-5.41118-.40989-.30883-3.26836,6.75015-3.4379,7.419-.31086,1.24382-.37992,2.62222-.77353,3.83125-.43229,1.32519-1.78127,1.79561-2.99766,2.56885-4.47426,2.84291-8.79485,5.86424-13.04251,9.02318-4.63676-8.24453.70809-18.20122,5.21232-25.11871a57.5413,57.5413,0,0,1,12.23291-12.99257c6.15964-4.98008,13.20905-8.96159,20.24609-12.59919a79.58086,79.58086,0,0,1,26.283-8.0833,85.10132,85.10132,0,0,1,14.62083-.415,24.31532,24.31532,0,0,1,6.9408,1.18993,22.66841,22.66841,0,0,1,2.98738,1.28509c.73568.37517,2.51613.76845,2.93346,1.33339,3.47825,4.52709,5.26025,9.04123,4.98884,14.73133a41.19464,41.19464,0,0,1-4.266,15.58192,47.77619,47.77619,0,0,1-10.20272,14.283A108.471,108.471,0,0,1,591.06446,86.649c-13.02518,9.50223-29.55242,17.76245-46.4362,15.64327a44.924,44.924,0,0,1-15.523-5.19862c-1.14472-.612-2.28182-1.23072-3.36287-1.95379-.72923-.48679-2.67659-2.68176-3.40851-2.761-1.00476-.10945-3.16773,1.93342-4.10968,2.55521q-10.74044,7.09075-20.95963,14.89615c-7.26286,5.51666-14.16941,11.40827-20.87268,17.577-2.85292,2.62279-5.68405,5.25323-8.45293,7.96564-.64425.63064-2.22379,2.95151-3.3887,3.05959a1.04942,1.04942,0,0,1-1.12511-1.24978c.18289-1.18868,2.685-2.9685,3.51483-3.82382"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Leaf-2",
    className: "cls-3",
    d: "M504.56581,38.67286c.10642-.98851,1.66633-1.5389,1.4373-.29762-.18706,1.0031-.11589.98163.43308,1.715.44615.59528,1.07886,1.12022,1.572,1.68862A24.67185,24.67185,0,0,1,510.802,45.624a32.76488,32.76488,0,0,1,3.616,9.50256c1.25538,5.80794,1.99765,12.0247,1.14933,17.88978a63.2,63.2,0,0,1-10.71982,26.39138c-3.29344,4.69179-7.13162,8.60993-12.78753,10.18012a18.7591,18.7591,0,0,1-8.77337.44269c-.76525-.15812-1.53112-.53534-2.29582-.64436-1.17856-.17-.84412-.17849-1.59544.95552q-1.22915,1.86159-2.47,3.71659a107.36887,107.36887,0,0,1-6.8866,9.45426,30.84956,30.84956,0,0,1-2.64509,2.77565c-.71147.65479-3.24271,3.40431-4.47319,3.3272-2.04757-.12787-.27495-1.96523.41012-2.47677.60055-.44729,1.18763-.92169,1.75022-1.41454a32.83533,32.83533,0,0,0,3.89521-4.09291c1.28276-1.589,2.463-3.26558,3.63853-4.93662,1.096-1.55828,2.165-3.13693,3.22115-4.72384q.88234-1.31887,1.75269-2.65017c.19917-.302.73758-.752.29386-.89661a50.38666,50.38666,0,0,0,3.20885-6.0243c1.2454-2.44551,2.471-4.91144,3.51118-7.45735a57.84594,57.84594,0,0,0,2.00042-5.61449,30.16007,30.16007,0,0,0,.77624-3.39679c.1078-.6324.79777-3.00723.44044-3.537.15378.228-1.15273,2.60616-1.28218,2.92748-.51285,1.27833-.94346,2.582-1.36125,3.89753a63.9103,63.9103,0,0,1-2.7343,7.15167c-.40514-.19113-.4255-2.10975-.52394-2.61872a24.60035,24.60035,0,0,0-.89361-3.37778,27.09975,27.09975,0,0,0-2.625-5.92145,11.77163,11.77163,0,0,1,.41544,2.76186c.19915,1.02847.44131,2.05808.741,3.06575.27822.9293.62259,1.83327.9858,2.733s1.31559,2.326,1.37924,3.32523c.00421.05989-.4311.29078-.42786.52984s.37357.713.36777.76878c-.04487.88306-1.04508,2.15238-1.43388,2.92968-1.01229,2.00964-2.04737,4.01053-3.075,6.01359-.31809.621-.41467,1.22537-.99057,1.25678-.61443.03328-1.72179-1.02189-2.207-1.39785a13.66513,13.66513,0,0,1-4.17994-5.167,24.511,24.511,0,0,1-2.0217-12.16408c1.14286-16.07054,5.68328-31.68379,17.06247-43.18648,4.71034-4.76213,12.41063-11.66525,19.55031-7.24984"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Leave_the_Leaf_",
    "data-name": "Leave the Leaf ",
    className: "cls-3",
    d: "M463.69,136.33892a1.10215,1.10215,0,0,1,.04866-.93726c.36273-.97435,2.90175-1.961,4.26925-2.49375.24391-.09466.4522-.17649.59212-.23564a30.95459,30.95459,0,0,1,3.60983-1.29034,108.01354,108.01354,0,0,1,11.43655-2.445c1.42432-.24751,2.90536-.49863,4.39985-.74518.27772-.04622.4893-.07.65964-.088.6113-.06721.6113-.06721.82553-.84143l.036-.14045a7.51321,7.51321,0,0,0,.1997-1.28991,9.20253,9.20253,0,0,1,.14522-1.06954,18.60807,18.60807,0,0,1,3.97246-7.83658,18.87694,18.87694,0,0,1,6.54084-5.05737,32.34313,32.34313,0,0,1,7.95879-2.48485,64.73928,64.73928,0,0,1,14.24407-1.15487,58.51363,58.51363,0,0,1,14.23081,2.09753c4.9272,1.391,10.11877,4.11449,15.87647,8.32492a32.78071,32.78071,0,0,1,7.21012,7.16824c.28027.38616.55545.79437.81833,1.215a26.85649,26.85649,0,0,1,1.55926,2.90048c.13154.28217.24963.58809.36241.88552a9.6881,9.6881,0,0,0,.53848,1.23893l.1025.18476c.07166.12975.12668.231.18074.31747.2173.34768.40407.422,1.10695.59a.74693.74693,0,0,1,.48177.28026.445.445,0,0,1-.07717.51993,1.221,1.221,0,0,1-1.26044.39273,9.13205,9.13205,0,0,1-.92114,5.50734,13.16607,13.16607,0,0,1-3.59362,4.17291,38.00035,38.00035,0,0,1-10.0594,5.2258,51.80062,51.80062,0,0,1-11.50577,2.87387,59.32972,59.32972,0,0,1-11.685.34556,85.30034,85.30034,0,0,1-23.19915-5.194,24.38916,24.38916,0,0,1-10.2908-6.79354,13.07169,13.07169,0,0,1-1.28271-1.71837,14.32517,14.32517,0,0,1-1.73935-4.20184c-.028-.11459-.06869-.259-.116-.42517a4.17173,4.17173,0,0,1-.26362-2.15954c.20395-.39633.59647-.39283,1.09382-.38764.147.00127.29817.0035.45632-.00572q.9132-.04834,1.83211-.10261c1.61035-.09137,3.27487-.18476,4.90939-.25822.259-.01208.58183-.05586.92347-.10547a5.4809,5.4809,0,0,1,2.33539-.01621.75475.75475,0,0,1,.12211.15953,1.583,1.583,0,0,0,.42962.48738c.14586.06922.36475-.04282.51092-.11649.07325-.03752.1307-.06635.14957-.05692a6.962,6.962,0,0,1,1.75864,1.76288c.25747.32139.50286.62911.717.84906.5989.61861,1.316,1.34143,2.09626,2.01061a31.2427,31.2427,0,0,0,2.49948,1.92369c.18243.12773.48294.28779.802.45866a5.6,5.6,0,0,1,1.52268,1.00233,27.06119,27.06119,0,0,0-4.31271-4.76448,24.65157,24.65157,0,0,0-2.7225-2.19c-.11554-.08109-.32934-.19865-.57781-.33581a5.48625,5.48625,0,0,1-1.55322-1.06816.282.282,0,0,1-.04971-.13992,64.33175,64.33175,0,0,1,7.64472.41075c1.314.14575,2.72155.28842,4.11513.34079.09063.00349.34715-.0106.6695-.02693a8.68417,8.68417,0,0,1,2.52418.04622c-.265-.424-1.83168-.72313-2.76756-.90355-.26924-.05342-.50434-.09752-.64288-.13239a30.18127,30.18127,0,0,0-3.4113-.66747,57.74844,57.74844,0,0,0-5.945-.45538c-2.81568-.08809-5.61546.03795-8.24214.1749-.60526.03159-1.23236.05088-1.84228.07123a31.67417,31.67417,0,0,0-4.96992.41043.268.268,0,0,0-.02745-.17034c-.0901-.14416-.36676-.06794-.6342.006a2.84207,2.84207,0,0,1-.27836.06784c-1.06233.17575-2.10124.34747-3.133.523-2.17936.37153-3.96694.69631-5.62637,1.02237l-.089.01791c-1.94606.38255-3.95826.77814-5.90113,1.29786a32.56673,32.56673,0,0,0-5.32045,1.89486c-.68243.31567-1.35627.66017-2.00319,1.02322C465.64007,136.32885,464.07317,136.952,463.69,136.33892Zm31.37791-15.56165a20.21,20.21,0,0,0-2.83062,5.54274c.54145-1.22049,1.06138-2.3037,1.58576-3.31186.11967-.22928.38064-.6872.63367-1.12954C494.77565,121.32667,495.07287,120.806,495.06789,120.77727Zm20.75417,3.85183c-.1802-.28832-2.94808,1.01707-3.39751,1.2508a14.809,14.809,0,0,0-3.92031,3.13887l-.00678.00424.00678-.00424a19.108,19.108,0,0,1,2.11015-1.14077c2.13537-1.08343,5.057-2.571,5.21647-3.14238A.133.133,0,0,0,515.82206,124.6291Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Touch",
    className: "cls-4",
    cx: 320.93403,
    cy: 261.87032,
    r: 16.231
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    className: "cls-5",
    x: 306.86703,
    y: 0.00433,
    width: 172.05299,
    height: 326.79199,
    rx: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Touch-2",
    className: "cls-4",
    cx: 392.35203,
    cy: 290.00532,
    r: 16.231
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Lens",
    className: "cls-4",
    cx: 378.28503,
    cy: 19.48233,
    r: 2.164
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Sensor",
    className: "cls-4",
    x: 385.86003,
    y: 17.31833,
    width: 22.724,
    height: 4.328,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-2",
    className: "cls-4",
    x: 322.01703,
    y: 30.30333,
    width: 141.754,
    height: 58.433,
    rx: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    className: "cls-6",
    x: 331.75603,
    y: 47.83333,
    width: 78.993,
    height: 8.765,
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-2",
    className: "cls-6",
    x: 331.75603,
    y: 62.44133,
    width: 53.022,
    height: 8.765,
    rx: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-7",
    cx: 448.62203,
    cy: 59.52033,
    r: 7.575
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    className: "cls-5",
    cx: 448.62103,
    cy: 59.51933,
    r: 3.246
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Background-2",
    className: "cls-4",
    x: 322.01703,
    y: 97.39333,
    width: 141.754,
    height: 45.448,
    rx: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    className: "cls-7",
    x: 364.21903,
    y: 111.02733,
    width: 78.993,
    height: 6.817,
    rx: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Name-2",
    className: "cls-7",
    x: 364.21903,
    y: 122.38933,
    width: 53.022,
    height: 6.817,
    rx: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    className: "cls-8",
    cx: 344.74103,
    cy: 120.11733,
    r: 12.985
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-3",
    className: "cls-4",
    x: 322.01703,
    y: 151.49833,
    width: 141.754,
    height: 45.448,
    rx: 4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-3",
    className: "cls-7",
    x: 331.75603,
    y: 165.13233,
    width: 78.993,
    height: 6.817,
    rx: 3
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-4",
    className: "cls-9",
    x: 331.75603,
    y: 176.49433,
    width: 53.022,
    height: 6.817,
    rx: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-3",
    className: "cls-7",
    cx: 448.62203,
    cy: 174.22233,
    r: 7.575
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-2",
    className: "cls-5",
    cx: 448.62103,
    cy: 174.22133,
    r: 3.246
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Background-4",
    className: "cls-4",
    x: 322.01703,
    y: 205.60133,
    width: 141.754,
    height: 45.448,
    rx: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Name-3",
    className: "cls-7",
    x: 364.21903,
    y: 219.23533,
    width: 78.993,
    height: 6.817,
    rx: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Name-4",
    className: "cls-7",
    x: 364.21903,
    y: 230.59733,
    width: 53.022,
    height: 6.817,
    rx: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Avatar-2",
    className: "cls-8",
    cx: 344.74103,
    cy: 228.32533,
    r: 12.985
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M201.528,275.57525a3.75887,3.75887,0,0,0,3.537-2.491L278.822,67.64434a3.76,3.76,0,0,0-2.269-4.80908h0a3.76213,3.76213,0,0,0-4.808,2.269l-73.756,205.43995a3.76,3.76,0,0,0,2.269,4.80908h.00006A3.75336,3.75336,0,0,0,201.528,275.57525Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    className: "cls-10",
    d: "M326.19,200.16418a93.11179,93.11179,0,1,1,5.48-30.624A93.12008,93.12008,0,0,1,326.19,200.16418Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1529",
    "data-name": "Rectangle 1529",
    className: "cls-12",
    x: 308.80922,
    y: 89.14433,
    width: 21.54004,
    height: 65.36401,
    rx: 5.73021,
    transform: "translate(96.89225 381.40879) rotate(-70.2421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    className: "cls-12",
    d: "M404.208,212.04753c3.664-12.81592-3.759-26.22193-16.3-30.72608L299.616,149.6215c-12.731-4.56909-27.2,1.28-32.362,13.782a25.12286,25.12286,0,0,0,13.58823,32.82813q.55953.23217,1.12976.43677l21.1,7.57495a3.12488,3.12488,0,0,1,1.8862,3.99658l-.00119.00342h0a3.12621,3.12621,0,0,1-3.99692,1.88916l-.00308-.00122-8.46-3.03809a13.13892,13.13892,0,0,0-16.806,7.926h0a13.13988,13.13988,0,0,0,7.92591,16.80761l.0011.00049,78.3,28.113a13.14194,13.14194,0,0,0,16.808-7.929h0a13.14,13.14,0,0,0-7.928-16.8059l2.139-5.95508a25.09991,25.09991,0,0,0,31.19439-16.939Q404.17045,212.1796,404.208,212.04753Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1530",
    "data-name": "Rectangle 1530",
    className: "cls-12",
    x: 207.66939,
    y: 201.55669,
    width: 20.27721,
    height: 49.79615,
    rx: 5.39326,
    transform: "translate(-68.94447 354.88804) rotate(-70.2421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    className: "cls-12",
    d: "M230.36,137.4943l-24.744-8.884a4.92707,4.92707,0,0,1-3.257-5.687,4.74064,4.74064,0,0,1,6.207-3.3291l10.49,3.76489a11.54491,11.54491,0,0,0,14.76676-6.96533l.00023-.00073h0a11.543,11.543,0,0,0-6.96063-14.76587l-.00336-.00122L159.018,77.269a4.745,4.745,0,0,0-6.066,2.86109l-4.6,12.80908a4.745,4.745,0,0,0,2.861,6.06592l10.547,3.78588a4.92712,4.92712,0,0,1,3.256,5.688,4.74271,4.74271,0,0,1-6.207,3.3291l-10.8-3.87695a4.74,4.74,0,0,0-6.06319,2.85889l-.00081.0022-4.6,12.8081a4.7279,4.7279,0,0,0,.622,4.37891l-3.709,10.3269-7.8-2.8a10.43285,10.43285,0,0,0-13,5.04907,10.144,10.144,0,0,0,4.82213,13.511q.44787.2124.91487.38013l68.5,24.592a10.43284,10.43284,0,0,0,13-5.04907,10.14311,10.14311,0,0,0-4.819-13.51075q-.4494-.21313-.918-.38134l-21.844-7.842a5.07,5.07,0,0,1-3.06076-6.48389l.00077-.0022h0a5.07,5.07,0,0,1,6.48317-3.0625l.00383.00147,45.556,16.355c5.949,2.135,12.784-.58594,15.1-6.47a11.544,11.544,0,0,0-6.50518-14.97364Q230.52689,137.55413,230.36,137.4943Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M238.443,277.75242A109.04834,109.04834,0,0,0,275.391,66.07029l-2.539,7.07691a101.52532,101.52532,0,1,1-68.61,191.10791l-2.541,7.0769A108.55747,108.55747,0,0,0,238.443,277.75242Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M273.931,311.15521c-15.225,0-31.009-23.3999-31.009-35.83692h-9.656c0,12.44092-15.784,35.83692-31.011,35.83692s-15.227,13.55688-15.227,13.55688h102.13S289.158,311.15521,273.931,311.15521Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "cls-13",
    d: "M52.75,156.96931l27.065,88.65894-5.126,65.03491H59.631l-2.113-62.13892-46.83-91.55591Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Leg-2",
    className: "cls-14",
    d: "M52.842,156.96931c-13.853,48.96606-16.611,83.74805-16.611,83.74805s-3.62,14.46411-19.237,69.947H2.442c.258-1.85791.775-1.2,1.971-10.2,3.724-28.041,5.489-56.58594,1.917-84.646a425.93,425.93,0,0,1-3.21-58.846Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    d: "M7.805,324.71218v-1.56L17.951,324.709H47.61v-3.1189s-18.78-5.073-30.439-13.269H.78L0,324.71218Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2",
    d: "M65.323,324.71218v-1.56L75.469,324.709h29.659v-3.1189s-18.78-5.073-30.439-13.269H58.298l-.78,16.39111Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Head-2",
    className: "cls-15",
    d: "M52.833,74.23541,49.66,51.7923c5.054,3.04492,10.021,4.51709,12.351,3.916,5.846-1.5,6.382-22.887,1.859-31.31689s-27.772-12.1001-28.945,4.6001a21.13967,21.13967,0,0,0,5.624,15.19091L34.1,74.24054Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-16",
    d: "M50.6,30.83337a15.19949,15.19949,0,0,1,5.2-5.321c8.235.12891,9.2-1.34595,9.2-6.322-1.329-.95288-6.023-2.55493-11.278-3.00708a13.59987,13.59987,0,0,0-8.917.658,11.57127,11.57127,0,0,0-8.389,7.69995c-5.109,8.822-1.231,18,4,21.13891,1.391-1.64794,2.605-3.24707,3.69-4.77587a4.68228,4.68228,0,0,1,3.832-8.00025C48.557,33.10437,49.743,32.14221,50.6,30.83337Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back",
    "data-name": "Coat Back",
    className: "cls-17",
    d: "M89.018,97.20349c14.184,1.834,19.814,3.47607,45.608-9.752l-7.342-11.46191c-9.233,2.29-16.054,1.3999-24.052,1.53906a57.79834,57.79834,0,0,1-20.663-3.44092c-9.088-3.27807-20.214-7.41211-34.112-12.56909l-8.453,9.74805C49.002,93.44738,78.825,95.89733,89.018,97.20349Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-7",
    d: "M37.359,56.28845l17.225,2.7c0,32.666,6.611,68.56006,11.163,91.50708.395,1.989.91,5.929-1.82,5.929l-47.565-2.96411C19.177,115.60632,23.113,79.19836,37.359,56.28845Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front",
    "data-name": "Coat Front",
    className: "cls-18",
    d: "M9.416,122.02941a196.19939,196.19939,0,0,0-7.312,39.625H55.859c10.406-26.3-12.786-105.36889-12.786-105.36889H36.248C21.125,65.07434,12.777,108.90734,9.416,122.02941Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    className: "cls-19",
    d: "M150.908,137.22424a93.07711,93.07711,0,0,1,85.525-61.634,93.12606,93.12606,0,0,0-20.39187,180.08716l.03589.01294a92.76526,92.76526,0,0,0,33.59,5.47A93.11933,93.11933,0,0,1,150.90419,137.235Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    className: "cls-21",
    d: "M123.274,145.63932c-7.977-25.26489,14.043-54.741,49.182-65.83593s70.093.395,78.068,25.6621-10.4,53.5-45.537,64.6001"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-22",
    d: "M178.149,172.27526l11.663,1.36109a.6.6,0,0,0,.618-.852l-7.709-16.624a.59971.59971,0,0,0-.7956-.29492l-.00441.00195-9.079,4.21a.6.6,0,0,0-.29508.79565l.00208.00439,5.124,11.051A.60522.60522,0,0,0,178.149,172.27526Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    className: "cls-22",
    d: "M90.413,19.79724a4.513,4.513,0,0,1,2.325-5.6941L122.238.42a4.521,4.521,0,0,1,5.85,1.8999l58.356,105.01489-53.565,24.842Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-23",
    d: "M135.563,139.29528l-2.688-7.114,53.565-24.842,3.694,6.646a5.755,5.755,0,0,1,.15,5.312c-3.06,6.313-9.774,23.071-3.782,38.50708a2.271,2.271,0,0,1-1.165,2.87793l-11.03,5.115a2.26817,2.26817,0,0,1-2.949-.97c-7.913-14.54493-25.041-20.2439-31.838-21.98609A5.76112,5.76112,0,0,1,135.563,139.29528Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-23",
    d: "M101.45,100.0614,78.529,37.44128a2.273,2.273,0,0,1,1.179-2.846l12.973-6.01709,3.545-1.645,37.1-17.19995a2.611,2.611,0,0,1,3.38,1.1001l14.618,26.31006a2.608,2.608,0,0,1-1.01225,3.54663c-.05551.03076-.11213.05981-.16975.08642L105.514,61.46716a2.60809,2.60809,0,0,1-3.4637-1.26734c-.02694-.05786-.05172-.11694-.0743-.17675L93.89,38.62316l-4.244,1.968a2.27793,2.27793,0,0,0-1.18,2.8479l19.733,53.908a2.275,2.275,0,0,1-1.179,2.84595l-2.477,1.148a2.275,2.275,0,0,1-3.02116-1.1062C101.49554,100.17785,101.47157,100.12023,101.45,100.0614Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-15",
    d: "M101.558,125.82922l37.828-11.116a85.55324,85.55324,0,0,0,23.267-.80908c1.709-.707,4.12-2.51294-1.357-4.032s-11.165-3.364-11.242-5.447,3.936-3.08594,3.335-6.07691q-.595-2.99195-18.492,7.208l-34.03,1.55Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-18",
    d: "M42.688,67.66149c14.754,49.42212,74.033,35.30005,88.623,36.85108l1.248,13.65991s-65.674,38.25-107.666-29.8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Photo_Background",
    "data-name": "Photo Background",
    className: "cls-6",
    x: 391.81107,
    y: 162.4013,
    width: 163.174,
    height: 108.21,
    rx: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Mountains",
    className: "cls-24",
    d: "M453.64506,193.3213l-48.093,77.293h96.187Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Mountains-2",
    className: "cls-25",
    d: "M500.88107,213.9333l-42.082,56.681h84.163Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    className: "cls-4",
    cx: 518.91607,
    cy: 198.4723,
    r: 15.459
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieRegion);
export default __webpack_public_path__ + "static/media/illustratie_region.afc3f8c3b3465f4136e74cd7f77730d2.svg";
export { ForwardRef as ReactComponent };